/**
 * Helper for specific functions to communicate with AdService 2.
 */
class AdServiceHelper {
	/**
	 * Pushes function or slot name to be queued and called when AdService 2 is available.
	 * @param {string|function} func - The slot name or function to be called.
	 */
	static servicePush (func) {
		window.AdService.push(func);
	}

	/**
	 * Listens to an AdService 2 event and calls function when event is fired.
	 * @param {string} eventName - The event name to listen to.
	 * @param {function} func - The function to be called when event is fired.
	 * @see {@link AdServiceHelper.servicePush}
	 */
	static listenEvent (eventName, func) {
		this.servicePush(() => {
			window.AdService.on(eventName, () => {
				func();
			});
		});
	}
}

export { AdServiceHelper };
